<template>
  <div>
    <div class="pane top-pane" :style="topHeroBg">
      <div class="mask">
        <b-container>
          <b-row class="hero">
            <b-col>
              <div>
                <div>
                  <h3 v-html="topHero.lead"></h3>
                  <h1 v-html="topHero.title"></h1>
                  <h6 v-html="topHero.sub"></h6>
                </div>
                <b-button class="btn-decorated px-4" :to="{name: 'account-signup'}">sign up now</b-button>
              </div>
            </b-col>
          </b-row>

          <b-row class="justify-content-center nav slide-wrapper">
            <b-col cols="12" lg="10">
              <div class="slides">
                <div v-for="(slide, index) in topSlides" :class="topSlideClass(index)" :key="index">
                  <h4>{{ slide.box.heading }}</h4>
                  <h3 class="u">{{ slide.box.subheading }}</h3>
                  <h6>{{ slide.box.tagline }}</h6>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>

    <div class="pane fan-pane">
      <b-container class="centered">
        <b-row>
          <b-col class="text-center hero">
            <h2>Time to meet the artists</h2>
            <p>
              Search and discover new artists, follow the ones you like, <br>
              back the ones you love!
            </p>
            <router-link :to="{name: 'account-signup'}" class="signup">
              SIGN UP NOW!
            </router-link>
          </b-col>
        </b-row>

        <b-row class="promo">
          <b-col cols="12" lg="4" class="text d-flex flex-column justify-content-center">
            <h2>
              Watch your <br> favorite artists
              <div class="live">&#9679; live</div>
            </h2>
            <p>
              Get in on live shows, studio sessions,
              backstage Q&A’s, and private concerts!
            </p>
          </b-col>
          <b-col class="donate" cols="12" lg="8">
            <img src="/static/img/landing/fan-live.png">
          </b-col>
          <div class="borders" />
        </b-row>
      </b-container>
    </div>

    <div class="pane playlists-pane">
      <b-container class="centered">
        <b-row class="promo">
          <b-col cols="12" lg="4" class="text p-4">
            <h2>
              Watch videos <br>
              on-demand
            </h2>
            <p>
              Create your own playlists, search by
              genre, mood, or instrument, and
              get real-time updates!
            </p>
            <b-button class="btn-decorated px-4" :to="{name: 'account-signup'}">sign up now</b-button>
          </b-col>
          <b-col class="videos" cols="12" lg="8">
            <img src="/static/img/landing/fan-ondemand.png">
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div class="pane artists-pane">
      <div class="hero">
        <h1>Welcome Artists</h1>
        <p>Put your best content out there!</p>
      </div>

      <div class="sub">
        <div class="sub-item sub-1">
          <div class="text">
            <h2 class="number">01</h2>
            <h2>
              <div class="pink">Join the artist studio</div>
            </h2>
            <p>Post activity of recent uploads, new releases, and of upcoming live streaming events.</p>
          </div>
          <div class="img">
            <img src="/static/img/landing/artist-studio.png">
          </div>
        </div>

        <div class="sub-item sub-2">
          <div class="bg">&nbsp;</div>
          <div class="text">
            <h2 class="number">02</h2>
            <h2>
              <div class="pink">Upload your videos</div>
            </h2>
            <p>Release singles, EPs, albums, or collections. Promote and distribute how you want. It’s up to you!</p>
          </div>
          <div class="img">
            <img src="/static/img/landing/artist-videos.png">
          </div>
          <div class="cta">
            <h3>Sell digital<br>tracks and<br>albums</h3>
          </div>
        </div>

        <div class="sub-item sub-3">
          <div class="bg">&nbsp;</div>
          <div class="text">
            <h2 class="number">03</h2>
            <h2>
              <div class="pink">Create up close & interactive moments</div>
            </h2>
            <p>Share something special. Make it a paid live streaming event, or leave it open for donations.</p>
          </div>
          <div class="img">
            <img src="/static/img/landing/artist-live.png">
          </div>
          <div class="cta">
            <h3>Receive<br>donations<br>anytime!</h3>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '@/assets/custom.scss';
@import '~bootstrap/scss/mixins/_breakpoints.scss';

  .btn-decorated {
    z-index: 1;
  }

  .pane {
    margin: 0 -15px 0 -15px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    overflow: hidden;

    h1,
    h2,
    h3 {
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  .top-pane {
    margin: -48px -15px 0 -15px;
    padding-top: 48px;
    height: 100vh;
    position: relative;
    transition: background-image 1s;
    position: relative;

    &:before {
      position: absolute;
      content: 'songback';
      font-size: 20rem;
      font-family: 'AvenirHeavy';
      letter-spacing: -1.5rem;
      opacity: .04;
      text-align: left;
      top: -180px;
      margin-left: 3%;

      @include media-breakpoint-down(lg) {
        content: '';
      }
    }

    .mask {
      background: linear-gradient(to bottom, rgba(0,0,0,0) 57%, $body-bg);
      bottom: 0;
      position: absolute;
      top: 0;
      width: 100%;
      display: flex;
      align-items: center;
      &:before {
        position: absolute;
        content: '';
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: linear-gradient(to top, rgba(0, 0, 0, 0) 20%, #171725 40%);
        opacity: .5;
      }
    }

    .container {
      height: 100vh;
      position: relative;
    }

    .kickstarter {
      h1 {
        font-size: 3.5rem;
        font-family: 'AvenirLight';
        font-weight: 600;
      }
      h3 {
        font-weight: 600;
        font-family: 'AvenirLight';
        margin-bottom: 1rem;
        font-size: 2.2rem;
      }
      img {
        width: 300px;
        margin-bottom: 14px;
      }
    }

    .hero {
      margin-top: 4em;
      height: 55vh;
      display: flex;
      align-items: center;
      h1 {
        width: 70%;
        font-size: 3.5rem;
        font-family: 'AvenirLight';
        font-weight: 600;
        margin-bottom: 1.5rem;
      }
      h3 {
        font-weight: 600;
        margin-bottom: 1rem;
        font-size: 2.2rem;
      }

      h6 {
        margin-bottom: 2em;
        font-size: 1.2rem;
        max-width: 60%;
        line-height: 26px;
      }
    }

    .nav {
      position: absolute;
      bottom: 0px;
    }

    .slide-wrapper {
      width: 100%;
    }

    .slides {
      margin-top: 5em;
      display: flex;
      position: relative;

      &:before {
        position: absolute;
        content: '';
        width: calc(100% + 13px);
        height: 100%;
        background: rgba(255,255,255,.05);
        z-index: 0;
        margin-top: 13px;
      }

      .slide {
        flex: 1 1 0;
        background-color: #1e1e2f;
        color: #f5a0bc;
        padding: 3em 2em;
        display: none;
        position: relative;
        z-index: 1;
        @media screen and (max-height: 840px) and (min-width: 990px) {
          padding: 1.8em 2em;
        }

        h3.u:after {
          display: block;
          content: ' ';
          margin-top: 0.5em;
          margin-bottom: 0.5em;
          width: 2em;
          height: 5px;

          background-color: $white;
          opacity: 0.14;
        }

        .u {
          font-weight: 600;
        }

        &.highlight {
          display: block;
          color: $white;
          background-image: linear-gradient(129deg, $darkish-pink, $blue-purple);
          z-index: 2;
        }

        @include media-breakpoint-down(md) {
          padding: 1.5em 2em;
          h3 {
            font-size: 1.5rem;
          }
          h4 {
            font-size: 1rem;
          }
          h6 {
            font-size: 1rem;
          }
        }
        @include media-breakpoint-down(sm) {
          h3 {
            font-size: 1.2rem;
          }
          h4 {
            font-size: 1rem;
          }
          h6 {
            font-size: 0.9rem;
          }
        }

      }
    }

    @include media-breakpoint-up(md) {
      .slides {
        .slide {
          transition: all 1s;
          display: block;

          &.highlight {
            transform: scale(1.1, 1.1);
          }
        }
      }
    }
    @include media-breakpoint-down(lg) {
      height: 800px;
      .mask {
        align-items: flex-start;
        padding-top: 4em;
      }
      .hero {
        height: auto;
        margin-top: 2em;
        h1 {
          font-size: 2.5rem;
          max-width: 100%;
          width: 100%;
        }
        h3 {
          font-size: 1.5rem;
        }
        h6 {
          font-size: 1rem;
          max-width: 100%;
        }
      }
      .kickstarter {
        height: auto;
        margin-top: 2em;
        h1 {
          font-size: 2.5rem;
          max-width: 100%;
          width: 100%;
        }
        h3 {
          font-family: 'AvenirLight';
          font-weight: 600;
          margin-bottom: 1rem;
          font-size: 2.2rem;
        }
        img {
          width: 320px;
          margin-bottom: 11px;
        }
      }
      .slides {
        margin-top: 5em;
        .slide {
          padding-top: 2em;
          padding-bottom: 2em;
        }
      }
      .nav {
        position: static;
        margin: 0;
      }
    }
    @include media-breakpoint-down(md) {
    }
    @include media-breakpoint-down(sm) {
      height: 650px;
      .nav {
        width: 100%;
        bottom: 60px;
      }
      .hero {
        /* height: 70vh; */
        /* margin-top: 0em; */
        /* padding: 0 0em; */
        h1 {
          font-size: 2rem;
        }
        h3 {
          font-size: 1.2rem;
        }
        h6 {
          font-size: .9rem;
          line-height: 1.5;
        }
      }
      .kickstarter {
        h1 {
          font-size: 2rem;
        }
        h3 {
          font-size: 1.2rem;
        }
        img {
          width: 220px;
          margin-bottom: 7px;
        }
      }
    }
    @include media-breakpoint-down(xs) {
      .hero {
        h1 {
          font-size: 1.5rem;
        }
        h3 {
          font-size: 1rem;
        }
      }
      .kickstarter {
        h1 {
          font-size: 1.5rem;
        }
        h3 {
          font-size: 1rem;
        }
        img {
          width: 180px;
          margin-bottom: 4px;
        }
      }
    }
    @media screen and (max-height: 840px) and (min-width: 990px) {
      height: 940px;
      .mask {
        align-items: flex-start;
      }
      .hero {
        height: auto;
        margin-top: 5em;
      }
      .kickstarter {
        height: auto;
        margin-top: 5em;
      }
      .nav {
        position: static;
        margin: 0;
      }
    }
  }

  .fan-pane {
    padding-top: 3em;
    padding-bottom: 10em;
    position: relative;

    @include media-breakpoint-down(md) {
      padding-bottom: 3em !important;
    }

    &:before {
      position: absolute;
      content: '';
      width: 100%;
      height: 350px;
      background: linear-gradient(to top, rgba(0, 0, 0, 0) 25%, #2c2d4c);
      top: 0;
    }

    @include media-breakpoint-up(md) {
      padding-top: 7em;
    }

    background-image: linear-gradient(to bottom, rgba(0,0,0,0) 20%, #1b1b2b), url(/static/img/landing/2.jpg);
    display: flex;
    flex-direction: column;

    .centered {
      align-items: center;
      justify-items: center;
    }

    .hero {
      h2 {
        font-size: 3.5rem;
        font-weight: 600;
      }
      p {
        color: #f5a0bc;
        font-size: 1.1rem;
        font-weight: 600;
      }
      .signup {
        color: $white;
        font-size: 1.2rem;
        font-weight: 600;
        text-decoration: underline;
      }
    }

    .promo {
      box-shadow: 5px 8px 10px 0 rgba(0, 0, 0, 0.63);
      margin-top: 6em;
      position: relative;

      &:before {
        position: absolute;
        content: '';
        width: 100%;
        height: 100%;
        top: -20px;
        left: 25px;
        border: 3px solid $darkish-pink;
      }
      @include media-breakpoint-down(md) {
        padding: 0 15px;
        box-shadow: none;
        &:before {
          content: none;
        }
      }

      .borders {
        position: absolute;
        border: 3px solid $darkish-pink;
        width: 100%;
        height: 100%;
        opacity: 0.56;
        top: -45px;
        left: 50px;
        z-index: 0;
        &:before {
          position: absolute;
          content: '';
          width: 100%;
          height: 100%;
          top: -25px;
          opacity: 0.36;
          left: 25px;
          border: 3px solid $darkish-pink;
        }
        @include media-breakpoint-down(md) {
          display: none;
        }
      }

      .text {
        padding: 160px 24px 160px 65px;
        .live {
          color: $darkish-pink;
        }
        p {
          font-size: 1em;
          font-weight: 600;
          line-height: 1.94;
        }
        h2 {
          line-height: 1.27;
          font-weight: 600;
          font-size: 2.6rem;
        }
        h2:after {
          display: block;
          content: ' ';
          margin-top: 0.5em;
          margin-bottom: 0.5em;
          width: 2em;
          height: 5px;
          background-color: $white;
        }
      }

      .donate,
      .text {
        background: #171725;
        z-index: 1;
      }

      .donate {
        position: relative;
        img {
          position: absolute;
          margin-top: 30px;
          margin-left: -10px;
        }
      }

      @include media-breakpoint-up(lg) {
        &.donate {
          position: relative;

          img {
            position: absolute;
            top: 20px;
            right: -45px;
            max-width: 100%;
          }
        }
      }
    }
    @include media-breakpoint-down(md) {
      .hero {
        h2 {
          font-size: 2rem;
        }
        p {
          font-size: 0.9rem;
          br {
            display: none;
          }
        }
      }
      .promo {
        margin-top: 3em;
        .text {
          padding: 25px;
          h2 {
            font-size: 1.8rem;
            br {
              display: none;
            }
          }
          p {
          font-size: 0.9rem;
          }
        }
        .donate {
          img {
            position: static;
            margin: 0 !important;
            width: 100%;
          }
        }
      }
    }
  }

  .playlists-pane {
    padding-bottom: 3em;
    background-image: linear-gradient(to bottom, #1b1b2b, rgba(0,0,0,0) 10%, #1c1c30), url(/static/img/landing/3.jpg);
    background-position: top center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    @include media-breakpoint-up(lg) {
      padding: 10em 0 5em 0;
    }

    .centered {
      align-items: center;
      justify-items: center;
    }

    .promo {

      .text {
        p {
          font-size: 1em;
          font-weight: 600;
          line-height: 1.94;
          @include media-breakpoint-down(md) {
            font-size: 0.9rem;
          }
        }
        h2 {
          line-height: 1.1;
          font-size: 3.2rem;
          font-family: 'AvenirHeavy';
          @include media-breakpoint-down(md) {
            font-size: 1.8rem;
            br {
              display: none;
            }
          }
        }
        h2:after {
          display: block;
          content: ' ';
          margin-top: 0.5em;
          margin-bottom: 0.5em;
          width: 2em;
          height: 5px;
          background-color: $white;
        }
      }

      .videos {
        img {
          @include media-breakpoint-down(md) {
            width: 100%;
            margin-top: 2em;
          }
        }
      }
    }
  }

  .artists-pane {
    background: $dark;

    .hero {
      text-align: center;

      h1 {
        font-size: 3.5em;
        font-weight: bold;
          @include media-breakpoint-down(md) {
            font-size: 1.8rem;
          }

        &:after {
          display: block;
          content: ' ';
          margin: 0.3em auto;
          width: 2em;
          height: 5px;
          background-color: $white;
        }
      }

      p {
        color: #f5a0bc;
        font-size: 1.1rem;
        font-weight: 600;
        @include media-breakpoint-down(md) {
          font-size: 0.9rem;
        }
      }
    }

    .sub {
      width: 100%;
      max-width: 1140px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;

      .sub-item {
        margin-top: 40px;
        margin-bottom: 40px;
        position: relative;
        z-index: 1;
        display: flex;
        flex-direction: column;
        align-items: center;

        @include media-breakpoint-up(md) {
          flex-direction: row;

          .text {
            width: 40%;
          }
        }

        h2 {
          line-height: 1.1;
          font-size: 3.2rem;
          font-family: 'AvenirHeavy';
          margin-top: 0;
          @include media-breakpoint-down(md) {
            font-size: 1.8em;
          }
        }
        p {
          font-size: 1.1em;
          font-weight: 600;
          line-height: 1.9;
          @include media-breakpoint-down(md) {
            font-size: 0.9em;
          }
        }

        .text {
          padding: 1em 0 1em 2em;
        }
      }

      .sub-1 {
        @include media-breakpoint-up(lg) {
          margin-left: 15%;
        }
        padding: 40px 60px 120px 35px;
        width: 85%;
        background: $darkish-pink-two;

        @include media-breakpoint-up(lg) {
          &:before {
            content: ' ';
            border: solid 2px $darkish-pink-two;
            position: absolute;
            top: -30px;
            left: 100px;
            width: 95%;
            height: 100%;
            z-index: -1;
          }
        }
        .pink {
          margin-top: 0.5em;
        }
        .number {
          font-size: 4.5em;
          font-family: 'AvenirHeavy';
          margin: -20px 0 -20px 0;
          text-shadow: 2px 2px 0 #000;
        }

        .img {
          width: 100%;
          position: relative;
          align-self: center;
          text-align: center;
          padding-top: 1em;
          padding-bottom: 1em;

          img {
            width: 80%;
          }

          @include media-breakpoint-up(lg) {
            img {
              display: block;
              position: absolute;
              width: 120%;
              top: 20px;
              left: 40px;
            }
          }
        }

        @include media-breakpoint-up(md) {
          .img {
            text-align: right;
            width: 60%;
          }
        }

        @include media-breakpoint-up(lg) {
          .img {
            min-height: 300px;
          }
        }
        @include media-breakpoint-down(md) {
          padding: 25px 25px 25px 0;
          .number {
            font-size: 2.5em;
          }
          h2 {
            font-size: 1.8em;
            margin-top: 1em;
            margin-bottom: .5em;
          }
          p {
            font-size: 0.9em;
          }
          .img {
            padding: 0 0 0 25px;
            img {
              width: 100%;
            }
          }
        }

      }

      .sub-2 {
        @include media-breakpoint-up(lg) {
          margin-right: 15%;
        }

        border: 2px solid $darkish-pink-two;
        background: $dark;
        position: relative;
        width: 85%;
        padding: 40px 80px 80px 35px;
        margin-top: 5em;
        margin-bottom: 6em;
        z-index: 1;
        @include media-breakpoint-down(md) {
          margin-top: 1em;
        }

        @include media-breakpoint-up(lg) {
          &:before {
            content: ' ';
            border: solid 1px $darkish-pink-two;
            position: absolute;
            top: 40px;
            left: 20px;
            width: 100%;
            height: 100%;
            z-index: -1;
          }
          &:after {
            content: '';
            position: absolute;
            width: 6px;
            height: 170px;
            background: #de3181;
            top: -170px;
            left: 80%;
          }
        }

        .bg {
          background: $dark;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
        }

        .text {
          z-index: 2;

          .pink {
            margin-top: 0.5em;
            color: $darkish-pink-two;
          }
          .number {
            font-size: 4.5em;
            font-family: 'AvenirHeavy';
            margin: -20px 0 -20px 0;
            text-shadow: 2px 2px 0 #000;
          }
        }

        .img {
          width: 60%;
          align-self: center;
          padding-top: 1em;
          padding-bottom: 1em;
          z-index: 2;
          text-align: center;
          min-height: 0;

          img {
            width: 70%;
          }
        }

        .cta {
          background: $darkish-pink-two;
          color: white;
          bottom: -70px;
          right: -40px;

          @include media-breakpoint-up(lg) {
            right: -40px;
          }

          z-index: 3;
          padding: 1em;
          &:before {
            content: ' ';
            border: solid 1px $darkish-pink-two;
            position: absolute;
            top: 99px;
            left: -20px;
            width: 100%;
            height: 61%;
            z-index: -1;
          }

          h3 {
            margin: 0;
            font-size: 3rem;
            font-family: 'AvenirHeavy';
          }
          @include media-breakpoint-down(md) {
            &:before {
              content: none;
            }
            h3 {
              font-size: 1.2rem;
            }
          }
        }

        @include media-breakpoint-up(sm) {
          .cta {
            position: absolute;
            bottom: -9em;
            right: -10em;
          }
        }
        @include media-breakpoint-down(md) {
          padding: 25px 25px 25px 0;
          .number {
            font-size: 2.5em !important;
          }
          h2 {
            font-size: 1.8em;
            margin-top: 1em;
            margin-bottom: .5em;
          }
          p {
            font-size: 0.9em;
          }
          .img {
            padding: 0 0 0 25px;
            width: 100%;
            img {
              width: 100%;
            }
          }
          .cta {
            bottom: -30px;
            right: 50px;
          }
        }
        @include media-breakpoint-down(sm) {
          .cta {
            bottom: -30px;
            right: 50px;
            position: absolute;
          }
        }
      }

      .sub-3 {
        margin-top: 10em;
        margin-bottom: 10em;
        padding: 40px 80px 5px 35px;
        width: 85%;
        @include media-breakpoint-down(md) {
          margin-top: -2.5em;
          padding: 25px 25px 0 0;
        }

        @include media-breakpoint-up(lg) {
          margin-left: 15%;
        }

        background: white;
        position: relative;
        z-index: 1;

        @include media-breakpoint-up(lg) {
          &:before {
            content: ' ';
            border: solid 2px white;
            position: absolute;
            top: -20px;
            left: -40px;
            width: 100%;
            height: 100%;
            z-index: -1;
          }
          &:after {
            content: '';
            position: absolute;
            width: 6px;
            height: 220px;
            background: #fff;
            top: -219px;
            left: 40%;
          }
        }

        .bg {
          background: white;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
        }

        .text {
          z-index: 2;
          color: $dark;

          .pink {
            margin-top: 0.5em;
            color: $darkish-pink-two;
            @include media-breakpoint-down(md) {
              margin-top: 1em;
              margin-bottom: 0.5em;
            }
          }
          .number {
            font-size: 4.5em;
            font-family: 'AvenirHeavy';
            margin: -20px 0 -20px 0;
            text-shadow: 2px 2px 0 #aaa;
            @include media-breakpoint-down(md) {
              font-size: 2.5em;
            }
          }
        }

        .img {
          width: 100%;
          position: relative;
          align-self: center;

          z-index: 2;
          @include media-breakpoint-down(md) {
            padding: 0 0 0 25px;
          }

          img {
            width: 100%;
          }

          @include media-breakpoint-up(lg) {
            img {
              display: block;
              position: absolute;
              top: -80px;
              left: 150px;
            }
          }
        }

        @include media-breakpoint-up(lg) {
          .img {
            align-self: stretch;
            /* width: 60%; */
          }
        }

        .cta {
          background: $darkish-pink-two;
          color: white;
          bottom: -70px;
          right: -40px;

          @include media-breakpoint-up(lg) {
            /* right: -6em; */
          right: -40px;
          }

          z-index: 3;
          padding: 1em;
          &:before {
            content: ' ';
            border: solid 1px $darkish-pink-two;
            position: absolute;
            top: 99px;
            left: -20px;
            width: 100%;
            height: 61%;
            z-index: -1;
          }
          @include media-breakpoint-down(md) {
            &:before {
              content: none;
            }
          }
          @include media-breakpoint-down(md) {
            bottom: -40px;
            position: relative;
          }

          h3 {
            margin: 0;
            font-size: 3rem;
            font-family: 'AvenirHeavy';
          }
          @include media-breakpoint-down(md) {
            h3 {
              font-size: 1.2rem;
            }
          }
        }

        @include media-breakpoint-up(sm) {
          .cta {
            position: absolute;
            bottom: -3em;
            right: 3em;
          }
        }

      }
    }

    @include media-breakpoint-up(xl) {
      .sub {
        /* width: 75%; */
        /* max-width: 1000px; */
      }
    }

    @include media-breakpoint-up(lg) {
      .sub {
        /* width: 90%; */
      }
    }
  }

</style>

<script>
export default {
  name: 'Landing',
  data () {
    return {
      topTimer: null,
      topSlides: [
        {
          hero: {
            lead: 'Join a MUSIC',
            title: 'Live Stream and <br> Video-On-Demand Experience',
            sub: 'Get access to videos, live streams, and downloads of your favorite artists, and interact with them 1-on-1.'
          },
          box: {
            heading: 'Bring',
            subheading: 'Art to Life',
            tagline: 'A video first experience.'
          }
        },
        {
          hero: {
            lead: 'Create a real connection, and',
            title: 'Fans will "Back" You <br> the Entire Way',
            sub: 'Take fans inside the studio, go behind the scenes, play a private concert, and broadcast it all live!'
          },
          box: {
            heading: 'Find',
            subheading: 'An Audience',
            tagline: 'Do it on a single platform.'
          }
        },
        {
          hero: {
            lead: 'Forget number of views/streams, just',
            title: 'Create the Most Valuable<br> Content Possible',
            sub: 'Find tools to completely customize a music experience for fans, one that they\'d be willing to pay for.'
          },
          box: {
            heading: 'Change',
            subheading: 'The Rules',
            tagline: 'Something fans will pay for.'
          }
        }
      ],
      currentTopSlide: 0
    }
  },
  computed: {
    topHeroBg () {
      return {
        'background-image': `url(/static/img/landing/top-${this.currentTopSlide}.jpg)`
      }
    },
    topHero () {
      return this.topSlides[this.currentTopSlide].hero
    }
  },
  mounted () {
    this.topTimer = setInterval(this.nextSlide, 7000)
  },
  beforeDestroy () {
    clearInterval(this.topTimer)
    this.topTimer = null
  },
  methods: {
    topSlideClass (index) {
      let cls = ['slide']
      if (index === this.currentTopSlide) cls.push('highlight')
      return cls
    },
    nextSlide () {
      if (!this.topSlides.length) return
      this.currentTopSlide = (this.currentTopSlide + 1) % this.topSlides.length
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Landing.vue